import React, { useState } from "react";
import "./Contact.css";
import emailjs from "emailjs-com";

export default function Contact() {
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_0no32jb",
        "template_bpc1ddc",
        e.target,
        "jTj-Y6jEx-ZGqkV3k",
      )
      .then(() => {
        setSent(true);
      })
      .catch(() => {
        alert("Something went wrong. Try again.");
      });

    e.target.reset();
  };

  return (
    <div className="contact">
      <h2>Contact Me</h2>
      <p>Have a project in mind? Send me a message.</p>

      <form onSubmit={handleSubmit}>
        <input type="text" name="name" placeholder="Your Name" required />

        <input
          type="tel"
          name="phone"
          placeholder="Your Phone Number"
          required
        />

        <input type="email" name="email" placeholder="Your Email" required />

        <textarea name="message" placeholder="Your Message" rows="6" />

        <button type="submit">Send Message</button>
      </form>

      {sent && <p className="success">✅ Message sent successfully!</p>}

      <p className="alt-contact">
        Or email me directly at: Studynpaste@gmail.com
      </p>
    </div>
  );
}
